import { Footer } from "@hub/ui/auth0/developers-components/src";
import { InHouseFooter } from "@hub/ui/auth0/footer";
import React, { PropsWithChildren } from "react";
import styles from "./auth0-footer.module.css";

interface Auth0FooterProps {
  compactFooter?: boolean;
}

export const Auth0Footer: React.FC<PropsWithChildren<Auth0FooterProps>> = ({
  compactFooter = false,
}) => {
  return compactFooter ? (
    <div className={styles.compactFooter}>
      <InHouseFooter />
    </div>
  ) : (
    <div className={styles.auth0Footer}>
      <Footer />
    </div>
  );
};
